const key = "remove-period-deadlines";

const applicable = (resp) => {
	return resp?.config.method === "GET" && resp?.config.url.match(/api\/forms(\/[0-9]*)?$/);
};

const stripPeriodDeadlines = (form) => {
	form?.Seasons?.forEach(season => {
		season?.Periods?.forEach(period => {
			delete period.Deadline;
		});
	});
};

const modify = (resp) => {
	if(!resp?.data?.Data)
		return;

	(Array.isArray(resp.data.Data) ? resp.data.Data : [resp.data.Data])
		.forEach(stripPeriodDeadlines);
};

export const removePeriodDeadlines = [key, applicable, modify];